/*
创建者 魏强(2018.1.30)
农特生鲜
*/
<template>
  <div id="ntsx-page">
    <!-- 顶部广告 -->
    <!-- <top-ad></top-ad> -->

    <div class="header-wrap">
      <header class="public-head-layout wrapper">
        <!--LOGO-->
        <div class="site-logo index_logo">
          <img :src="logoImg" class="pngFix">
        </div>
        <div class="head-user-menu">
          <img :src="theadiconImg" class="theadicon">
          <dl class="my-cart" v-handle-hover>
            <a @click.stop.prevent="cCheckout">
              <img :src="theadcartImg">
            </a>
            <dd class="my-cart-block">
              <div class="sub-title">
                <h4>最新加入的商品</h4>
              </div>
              <div class="incart-goods-box">
                <p v-show="cartNums === 0" style="text-align:center;border:0px!important;">您的菜篮中还没有任何商品
                </p>
                <div class="incart-goods">
                  <dl v-for="(item,index) in cartProducts" :key="index" class="item">
                    <dd class="goods-thumb">
                      <span class="thumb size40">
                        <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" :title="item.name" target="_blank">
                          <img :src="item.imageDefault" alt="item.name" height="40" style="cursor: pointer;" width="40" />
                        </router-link>
                      </span>
                    </dd>
                    <dt class="goods-name">
                      <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" :title="item.name" target="_blank">
                        {{item.name}}
                      </router-link>
                    </dt>
                    <dd class="goods-price">
                      <p>￥{{item.couponPrice}}×{{item.num}}</p>
                    </dd>
                    <dd class="handle">
                      <a class="delete" @click.stop.prevent="cDeleteCart(item.goodsId)">删除</a>
                    </dd>
                  </dl>
                </div>
                <div v-show="cartNums > 0" class="checkout">
                  <a class="btn-cart" @click.stop.prevent="cCheckout">结算菜篮中的商品</a>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </header>
    </div>
    <Affix>
      <nav class="public-nav-layout">
        <div class="wrapper">
          <ul class="site-menu">
            <li>
              <router-link to="/fresh-agricultural/3">地方特产</router-link>
            </li>
            <li>
              <router-link to="/fresh-agricultural/117">生鲜果蔬</router-link>
            </li>
            <li>
              <router-link to="/fresh-agricultural/18">粮油调味</router-link>
            </li>
            <li>
              <router-link to="/fresh-agricultural/8">休闲食品</router-link>
            </li>
            <li>
              <router-link to="/fresh-agricultural/1">名酒冲调</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </Affix>
    <nav class="public-nav-side" id="public-nav-side">
      <ul>
        <li>
          <router-link to="/fresh-agricultural/3">地方特产</router-link>
        </li>
        <li>
          <router-link to="/fresh-agricultural/117">生鲜果蔬</router-link>
        </li>
        <li>
          <router-link to="/fresh-agricultural/18">粮油调味</router-link>
        </li>
        <li>
          <router-link to="/fresh-agricultural/8">休闲食品</router-link>
        </li>
        <li>
          <router-link to="/fresh-agricultural/1">名酒冲调</router-link>
        </li>
      </ul>
    </nav>
    <banner :data="banners"></banner>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

  </div>
</template>
<script>
import logoImg from '../../assets/images/ntsx/logo.png';
import theadiconImg from '../../assets/images/ntsx/theadicon.png';
import theadcartImg from '../../assets/images/ntsx/theadcart.png';
import topAd from './top-ad';
import banner from './banner';
import { mapGetters } from 'vuex'
export default {
  components: {
    banner,
    topAd
  },
  directives: {
    handleHover(el) {
      $(el).hover(
        function () {
          $(el).addClass("hover");
        }, function () {
          $(el).removeClass("hover");
        });
    }
  },
  computed: {
    // 获取购物车
    ...mapGetters({
      cartProducts: 'cartProducts',
      cartTotalPrice: 'cartTotalPrice',
      cartNums: 'cartNums'
    })
  },
  data() {
    return {
      logoImg,
      theadiconImg,
      theadcartImg,
      banners: []
    }
  },
  created() {
  },
  mounted() {
    $(document).on("scroll", function (e) {
      if ($(this).scrollTop() > 150) {
        $("#public-nav-side").show();
      } else {
        $("#public-nav-side").hide();
      }
    });
  },
  destoryed() {
    $(document).unbind("scroll");
  },
  methods: {
    //从购物车中删除
    cDeleteCart(id) {
      this.$store.dispatch('deleteCart', id);
    },
    //购物车付款
    cCheckout() {
      this.$router.push({ path: '/shopping-cart' });
    }
  }
}
</script>

<style lang="less">
@import "../../assets/css/ntsx.less";
</style>
<style lang="css" scoped>
.my-cart-block {
  display: none;
}
#ntsx-page .public-nav-layout .site-menu li a.router-link-active {
  background-color: #559300;
}
#ntsx-page #public-nav-side li a.router-link-active {
  background-color: #559300;
  color: #fff;
}
#ntsx-page .public-nav-layout .site-menu li a {
  padding: 0 50px;
}

@media (max-width: 1399px) {
  .public-nav-side {
    margin-left: -670px !important;
  }
  .public-nav-side ul {
    font: 12px/1.5 "Microsoft Yahei" !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?337aa00f